import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ApiUrlsEnum } from '@lib/enums';
import { IFilterBase, IPaginationResponse, IParticipate } from '@lib/interfaces';
import { httpParamsUtil } from '@lib/utils';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable()
export class ParticipateDataService {

  constructor(
    private readonly http: HttpClient,
  ) {
  }

  public get(filter: Partial<IFilterBase>): Observable<IPaginationResponse<IParticipate>> {
    const params = httpParamsUtil(filter);

    return this.http.get<IPaginationResponse<IParticipate>>(`${environment.host}${ApiUrlsEnum.membersList}`, { params });
  }

  public details(id: number): Observable<IParticipate> {
    return this.http.get<IParticipate>(`${environment.host}${ApiUrlsEnum.memberDetail}${id}`);
  }

  public delete(id: number): Observable<any> {
    return this.http.delete<any>(`${environment.host}${ApiUrlsEnum.deleteMember}${id}`);
  }
}
